import React from 'react';
import ReportViewWrapper, { ReportComponentType } from './report-view-wrapper';
import { useReportViewCustomize } from '../manage-client-views';

interface ReportComponentWrapperProps {
  componentType: ReportComponentType;
  className?: string;
  children: React.ReactNode;
  defaults?: boolean;
  fieldSelection?: boolean;
  bottom?: boolean;
  maxDefaults?: number;
}

/**
 * Wrapper component that conditionally wraps children with ReportViewWrapper
 * when in customize mode (via context), otherwise just renders children as-is.
 * This allows minimal changes to reports.tab.tsx - just wrap each component.
 */
const ReportComponentWrapper: React.FC<ReportComponentWrapperProps> = ({
  componentType,
  className,
  children,
  defaults = true,
  fieldSelection = true,
  bottom,
  maxDefaults = 1,
}) => {
  const customizeContext = useReportViewCustomize();

  // If not in customize mode, just render children
  if (!customizeContext) {
    return (
      <>
        {children}
      </>
    );
  }

  // In customize mode, wrap with ReportViewWrapper
  return (
    <ReportViewWrapper
      componentType={componentType}
      className={className}
      enabled={customizeContext.componentStates[componentType]}
      onStateChange={customizeContext.handleStateChange}
      onFieldSelectionChange={customizeContext.handleFieldSelectionChange}
      onDefaultSelectionChange={customizeContext.handleDefaultSelectionChange}
      fieldSelection={fieldSelection}
      bottom={bottom}
      defaults={defaults}
      maxDefaults={maxDefaults}
    >
      {children}
    </ReportViewWrapper>
  );
};

export default ReportComponentWrapper;
